import { render } from "./Analysis.vue?vue&type=template&id=1ec24fb7&ts=true"
import script from "./Analysis.vue?vue&type=script&lang=ts"
export * from "./Analysis.vue?vue&type=script&lang=ts"

import "./Analysis.vue?vue&type=style&index=0&id=1ec24fb7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__